<template>
    <div class="main-toolbar">
        <slot />
    </div>
</template>

<script>
    export default {
        name: "MainToolbar"
    }
</script>

<style scoped>
    .main-toolbar {
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
        max-width: 100%;
        margin-bottom: 1rem;
    }

    .main-toolbar > div:not(:last-child) {
        margin-right: 8px;
    }
</style>